<!-- 题干组件 -->
<template>
  <div class="container" :class="[seasonClass, groupClass, tvClass]">
    <div class="screen" :style="pageStyle">
      <div class="page">
        <!-- <img class="qr" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/leftQR-shanghai.png" alt=""> -->
        <img class="qr" @click="toFullOrExit" :src="'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/' + (districtId === '9' ? 'left-photo-huabei' : 'left-photo') + '.jpg'" alt="">
        <div class="content">
          <div class="left" :class="{ 'nine-grid-game': info.quizType === 7 }">
            <div class="title">
              <div class="cn">{{ info.typeName }}</div>
              <div class="en">{{ info.typeEngName }}</div>
            </div>
            <div :class="'desc desc' + query.group">
              <div class="cn"><template v-if="query.group === '1'"></template>{{ info.introduce }}</div>
              <div class="en word-break"><template v-if="query.group === '1'"></template>{{ info.engIntroduce }}</div>
            </div>
            <div class="stem-area">
              <!-- 16格极速拼字 -->
              <div class="type1" v-if="info.quizType === 5">
                <el-row>
                  <el-col :span="6" v-for="(font,index) of fontList" :key="index">
                    <div class="block">{{ font }}</div>
                  </el-col>
                </el-row>
              </div>
              <!-- 魔力部首 -->
              <div class="type2" v-if="info.quizType === 4">
                <div class="block center">{{ info.question }}</div>
                <div class="block" :class="'block'+index" v-for="(font,index) of fontList" :key="index">{{ font }}</div>
              </div>
              <!-- 古往今来 -->
              <div class="type3" v-if="info.quizType === 6">
                <el-row style="margin-bottom: 10px;">
                  <el-col :span="6" v-for="(font,index) of imgList" :key="index">
                    <div class="block">
                      <img :src="font" alt="">
                    </div>
                  </el-col>
                </el-row>
                <el-row class="area2">
                  <el-col :span="8" v-for="(font,index) of fontList" :key="index">
                    <div class="block2">{{ font }}</div>
                  </el-col>
                </el-row>
              </div>
              <!-- 九宫格 -->
              <div class="type4" v-if="info.quizType === 7">
                <div class="grid-container">
                  <!-- 左侧九宫格 -->
                  <div class="left-grid-wrapper">
                    <div class="grid-title">左侧选择区</div>
                    <el-row class="area2">
                      <el-col
                        :span="8"
                        v-for="(item, index) of fontList"
                        :key="'left-' + index"
                      >
                        <div
                          class="block2"
                          :class="item.active ? 'active' : ''"
                          @click="answerFnLeft(item, index)"
                        >
                          {{ item.font }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <!-- 右侧九宫格 -->
                  <div class="right-grid-wrapper">
                    <div class="grid-title">右侧选择区</div>
                    <el-row class="area2">
                      <el-col
                        :span="8"
                        v-for="(item, index) of fontListB"
                        :key="'right-' + index"
                      >
                        <div
                          class="block2"
                          :class="item.active ? 'active' : ''"
                          @click="answerFnRight(item, index)"
                        >
                          {{ item.font }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <img class="choice-pic" :src="info.choicePic" alt="">
              </div>
            </div>
            <!-- 有组别进度条 -->
            <div class="progress1" v-if="info.quizType !== 7 && query.group === '1' && progress.length">
              <div class="progress-item" v-for="item of progress" :key="item" :class="quizIngCount === item ? 'quizIngCount' : quizIngCount > item ? 'done' : ''">{{ item }}</div>
            </div>
            <!-- 无组别进度条 -->
            <div class="progress2" v-if="query.group === '2' && progress.length">
              <div class="progress-item" v-for="item of progress" :key="item" :class="quizIngCount === item ? 'quizIngCount' : quizIngCount > item ? 'done' : ''">{{ item }}</div>
            </div>
          </div>
          <div class="right">
            <img class="logo" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png" alt="">
            <div class="redbar" :style="query.phase === '3' ? 'right: 190px' : 'right: 190px'">REGIONAL FINAL</div>
            <div class="time-bg">
              <div>{{ seconds }}s</div>
            </div>
          </div>
        </div>
        <img class="qr" @click="reloadData" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/right.jpg" alt="">
      </div>
      <img src="../../../assets/img/fs.png" class="fullscreen" @click="toFullOrExit" alt="">
      <img src="../../../assets/img/refresh.png" class="fullscreen-top refresh" @click="reloadData" alt="">
      <img src="../../../assets/img/fs.png" v-if="query.group === '1'" class="fullscreen-top" @click="toFullOrExit" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pageStyle: {
        width: '100%'
      },
      info: {},
      typeStr: [
        { cn: '极速拼字', en: 'Speed Spell' },
        { cn: '魔力部件', en: 'Magic Components' },
        { cn: '古往今来', en: 'Past and Present' }
      ],
      // pageTitle: {
      //   cn: '',
      //   en: ''
      // },
      dict_group: this.$userInfo.dict_group(),
      startTimer: false, // 是否开始了倒计时
      countDownTimer: null, // 倒计时计时器
      seconds: 60,
      defaultSeconds: 60, // 默认每题秒数
      quizIng: -1,
      pause: false,
      progress: [],
      isDiscard: false, // 作废

      imgList: [],
      fontList: [],
      fontListB: [], // 右侧九宫格选项列表
      quizType: '',
      seasonClass: '',
      groupClass: '',
      tvClass: '',
      questionId: '',
      // 九宫格答题相关
      chooseFonts: [], // 选项列表
      chooseFontsLeft: [], // 左边九宫格选择的选项
      chooseFontsRight: [], // 右边九宫格选择的选项
      districtId: ''
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestory () {
    clearInterval(this.timer)
    this.timer = null
    window.removeEventListener('resize', this.getScreenSize)
  },
  created () {
    document.title = '汉英双拼大会'
    const query = this.$route.query
    this.query = query
    this.districtId = query.districtId
    this.seasonClass = 'season2'
    if (query.TV) {
      this.groupClass = ''
    } else {
      this.groupClass = 'group' + query.group
    }

    this.tvClass = query.TV
    this.getMatchStart()
    this.timer = setInterval(() => {
      this.getMatchStart()
    }, 3000)
  },
  methods: {
    reloadData () {
      this.getMatchStart()
    },
    getScreenSize () {
      // const w = window.innerWidth // 屏幕宽
      const h = window.innerHeight // 屏幕高
      // 1920/1080
      const calcWidth = 1920 * h / 1080
      // console.log(calcWidth, w)
      // if (calcWidth < w) {
      if (this.seasonClass === 'season1') {
        this.pageStyle.width = parseInt(calcWidth) + 'px'
      }
      // } else {
      //   this.pageStyle.width = '100%'
      // }
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    // 查询考试开始状态
    getMatchStart () {
      // console.log('获取考场状态')
      const params = {
        activityType: this.query.activityType,
        season: this.query.season,
        isGroup: this.query.group,
        raceSchedule: this.query.raceSchedule,
        round: this.query.round,
        examinationRoomId: this.query.examinationRoomId,
        phase: this.query.phase
      }
      if (Number(params.isGroup) === 1) {
        params.level = this.query.level
      }
      this.$http.get('slabForm/queryNationalGroupFormInfoList', { params, showLoading: false }).then(res => {
        if (res.code === 200) {
          if (res.data.matchTng === 1) {
            if (res.data.groupFormInfo) {
              if (this.questionId !== res.data.groupFormInfo.id && this.quizIng !== 0) { // 防止裁判系统点击过快导致题目未切换
                this.questionId = res.data.groupFormInfo.id // 题目id
                this.quizIng = 0 // 小题结束答题
                clearInterval(this.countDownTimer)
                this.countDownTimer = null
                this.seconds = 0
                this.startTimer = false
                if (!this.isDiscard) {
                  this.quizIngCount = this.quizIngCount + 1
                }
              } else {
                this.questionId = res.data.groupFormInfo.id // 题目id
                this.quizIng = res.data.groupFormInfo.quizIng // 小题开始答题
                // 进度条
                if (res.data.nationalFormCount && res.data.quizIngCount) {
                  this.quizIngCount = res.data.quizIngCount
                  if (res.data.groupFormInfo.isDiscard === 1) {
                    this.quizIngCount = this.quizIngCount + 1
                  }
                  this.progress = []
                  for (var i = 0; i < res.data.nationalFormCount; i++) {
                    this.progress.push((i + 1))
                  }
                // console.log(this.progress)
                }
                if (!this.startTimer && res.data.groupFormInfo.isDiscard !== 1) {
                  this.info = { ...res.data.groupFormType, ...res.data.groupFormInfo }
                  // this.pageTitle.cn = this.query.group === '2' ? this.typeStr[this.info.quizType - 1].cn : `小组赛${this.levelFormatter(Number(this.query.level), 'cn')}`
                  // this.pageTitle.en = this.query.group === '2' ? this.typeStr[this.info.quizType - 1].en : `Group Competition ${this.levelFormatter(Number(this.query.level), 'en')}`

                  // 切换题型
                  if (!this.quizType) {
                    this.quizType = this.info.quizType
                  } else {
                    if (this.quizType !== this.info.quizType) {
                      this.quizType = this.info.quizType
                      this.fontList = []
                      this.imgList = []
                    }
                  }
                  // 无组别题型3每次清空选项
                  if (this.quizType === 6) {
                    this.fontList = []
                    this.imgList = []
                  }
                  // 九宫格答题区每次清空选项
                  if (this.quizType === 7) {
                    this.fontList = []
                    this.fontListB = []
                    this.chooseFonts = []
                    this.chooseFontsLeft = []
                    this.chooseFontsRight = []
                  }
                  this.startCountDown()
                  const options = this.info.choice.split(',')
                  if (!this.fontList.length) {
                    this.fontList = options
                    if (this.info.quizType === 6) { // 古往今来选项
                      const imgOpt = this.info.choicePic.split(',')
                      this.imgList = imgOpt
                    }
                    if (this.info.quizType === 7) { // 九宫格答题区选项
                    // 将选项分成两部分，分别设置给两个九宫格
                      const leftOptions = this.info.choice.split(',')
                      const rightOptions = this.info.choiceB.split(',')
                      const fontList = leftOptions.map(item => {
                        return {
                          active: false,
                          font: item,
                          isImg: item.includes('http') ? 1 : 0
                        }
                      })
                      this.fontList = fontList

                      const fontListB = rightOptions.map(item => {
                        return {
                          active: false,
                          font: item,
                          isImg: item.includes('http') ? 1 : 0
                        }
                      })
                      this.fontListB = fontListB
                    }
                  }
                }
                if (this.startTimer) {
                // 重新计时
                // if (this.info.countDown === 3) {
                //   this.seconds = 60
                // }
                // 暂停计时
                  if (res.data.groupFormInfo.countDown === 1 && !this.pause) {
                    console.log('暂停计时')
                    clearInterval(this.countDownTimer)
                    this.countDownTimer = null
                    this.pause = true
                  }
                  // 继续计时
                  if (res.data.groupFormInfo.countDown === 2 && this.pause) {
                    this.continueFn()
                  }
                  // 作废
                  if (res.data.groupFormInfo.isDiscard === 1 && !this.isDiscard) {
                    this.isDiscard = true
                    clearInterval(this.countDownTimer)
                    this.countDownTimer = null
                  }
                  if (res.data.groupFormInfo.isDiscard === 0 && this.isDiscard) {
                    this.isDiscard = false
                  }
                }
              }
            } else {
              this.quizIng = 0 // 小题结束答题
              clearInterval(this.countDownTimer)
              this.countDownTimer = null
              this.seconds = 0
              this.startTimer = false
              if (!this.isDiscard) {
                this.quizIngCount = this.quizIngCount + 1
                console.log('quizIngCount---', this.quizIngCount)
              }
            }
          } else if (res.data.matchTng === 2) {
            clearInterval(this.timer)
            this.timer = null
            this.nextPage()
          }
        }
      })
    },
    nextPage () {
      // this.$router.push(`/semiRank?${this.$xcUtils.serialize(this.query)}`)
    },
    // 开始倒计时
    startCountDown () {
      console.log('开始倒计时～')
      this.startTimer = true
      this.seconds = this.defaultSeconds
      this.countDownTimer = setInterval(() => {
        if (this.seconds === 0) { // 倒计时自动结束
          clearInterval(this.countDownTimer)
          this.countDownTimer = null
        } else {
          this.seconds--
        }
      }, 1000)
    },
    continueFn () {
      console.log('继续倒计时～')
      this.pause = false
      this.countDownTimer = setInterval(() => {
        if (this.seconds === 0) { // 倒计时自动结束
          clearInterval(this.countDownTimer)
          this.countDownTimer = null
        } else {
          this.seconds--
        }
      }, 1000)
    },
    levelFormatter (level, type) {
      return this.dict_group.find(item => item.dictCode === level)[type]
    },
    // 左边九宫格选择答案
    answerFnLeft (item, index) {
      const fontList = [...this.fontList]
      const indexInFontList = fontList.findIndex(f => f.font === item.font)

      // 如果当前选项已经选中，则取消选择
      if (fontList[indexInFontList].active) {
        fontList[indexInFontList].active = false
        this.chooseFontsLeft = []
      } else {
        // 单选逻辑：先清除所有选择，再选中当前选项
        fontList.forEach(f => {
          f.active = false
        })
        fontList[indexInFontList].active = true
        this.chooseFontsLeft = [item.font]
      }

      this.fontList = fontList
      // 合并两边的选择结果
      this.chooseFonts = [...this.chooseFontsLeft, ...this.chooseFontsRight]
    },
    // 右边九宫格选择答案
    answerFnRight (item, index) {
      const fontListB = [...this.fontListB]
      const indexInFontList = fontListB.findIndex(f => f.font === item.font)

      // 如果当前选项已经选中，则取消选择
      if (fontListB[indexInFontList].active) {
        fontListB[indexInFontList].active = false
        this.chooseFontsRight = []
      } else {
        // 单选逻辑：先清除所有选择，再选中当前选项
        fontListB.forEach(f => {
          f.active = false
        })
        fontListB[indexInFontList].active = true
        this.chooseFontsRight = [item.font]
      }

      this.fontListB = fontListB
      // 合并两边的选择结果
      this.chooseFonts = [...this.chooseFontsLeft, ...this.chooseFontsRight]
    }

  }
}
</script>
<style scoped lang="less">
.container{
  width: 100vw;
  height: 100vh;
  position: relative;
  .div-left{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    background-color: #FFF;
  }
}
.season1{
  background-color: #B81C25;
}
.screen{
  // width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  color: #000;
  font-family: 'regular';
  margin: 0 auto;

  .right-bg{
    width: 50%;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #b81c25;
    z-index: -1;
  }
}
.page{
  // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  overflow: hidden;
}

  .left{
    width: 50%;
    height: 100%;

    .title{
      margin: 50px auto 40px;
      width: 100%;
      height: 100px;
      padding-top: 10px;
      box-sizing: border-box;
      // line-height: 64px;
      text-align: center;
      background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;
      color: #fff;
      .cn{
        font-size: 32px;
      }
      .en{
        font-size: 26px;
      }
    }
  .desc{
    &.desc2{
      margin-left: 40px;
      margin-bottom: 20px;
      line-height: 30px;
      .cn{
        font-size: 20px;
        margin-bottom: 10px;
      }
      .en{
        font-size: 18px;
      }
    }
    &.desc1{
      width: 70%;
      margin: 60px auto 0;
      line-height: 44px;
      .cn{
        font-size: 32px;
        margin-bottom: 20px;
      }
      .en{
        font-size: 28px;
      }
    }
  }
}
.right{
  width: 50%;
  height: 100%;
  position: relative;
  .logo{
    height: 280px;
    position: absolute;
    right: 40px;
    top: 42px;
  }
  .time-bg{
    width: 840px;
    height: 840px;
    margin: 130px auto 0;
    box-sizing: border-box;
    padding-bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_time_bg_1.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 90%;
    font-size: 160px;
    div{
      height: 200px;
      line-height: 200px;
    }
  }
}
.fullscreen{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  cursor: pointer;
}
.fullscreen-top{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  top: 10px;
  cursor: pointer;
}
.refresh{
  left: 50px !important;
}
.stem-area{
  width: 460px;
  min-height: 460px;
  margin: 0 auto;
}

.type1{
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 54px;
    background-color: #fbb201;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border-radius: 16px;
    margin-bottom: 16px;
  }
}
.type2{
  position: relative;
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 54px;
    background-color: #f96950;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border-radius: 16px;
    margin-bottom: 16px;
    position: absolute;
    &.block0{ top: 0; left: 0; }
    &.block1{ top: 0; left: 116px; }
    &.block2{ top: 0; left: 232px; }
    &.block3{ top: 0; left: 348px; }
    &.block4{ top: 116px; left: 0; }
    &.block5{ top: 116px; left: 348px; }
    &.block6{ top: 232px; left: 0; }
    &.block7{ top: 232px; left: 348px; }
    &.block8{ top: 348px; left: 0; }
    &.block9{ top: 348px; left: 116px; }
    &.block10{ top: 348px; left: 232px; }
    &.block11{ top: 348px; left: 348px; }
  }
  .center{
    width: 218px;
    height: 218px;
    position: absolute;
    top: 116px;
    left: 116px;
    border-radius: 36px;
    font-size: 140px;
  }
}
.type3{
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border: 4px solid #b81c25;
    border-radius: 20px;
    margin-bottom: 10px;
    img{
      height: 98%;
      border-radius: 20px;
    }
  }
  .area2{
    width: 340px;
    margin: 0 auto;
    .block2{
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'fzcsk';
      font-size: 54px;
      background-color: #e5e5e5;
      box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
      border-radius: 20px;
      margin-bottom: 14px;
    }
  }
}
.progress2{
  margin: 20px auto 0;
  width: 680px;
  height: 80px;
  display: flex;
  align-items: center;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 20px;
  .progress-item{
    flex: 1;
    height: 60px;
    line-height: 54px;
    font-size: 42px;
    color: #FFF;
    text-align: center;
    margin: 3px;
    background-color: #ababab;
    border-radius: 16px;
  }
  .quizIngCount{
    background-color: #066e84;
  }
  .done{
    background-color: #A50400;
  }
}
.progress1{
  margin: 120px auto 0;
  width: 600px;
  height: 100px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  .progress-item{
    width: 130px;
    height: 130px;
    color: #fff;
    font-size: 76px;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon3.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon4.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin: 6px;
  }
  .quizIngCount{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon2.png);
  }
  .done{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon1.png);
  }
}

.season1 {
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_bg.png);
  }
}
.season2 {
  .page{
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4bg.jpg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .qr{
    height: 100%;
    width: auto;
  }
  .content{
    flex: 1;
  }
  .left{
    // background: rgba(255, 248, 225, .7);
    background: rgba(250, 250, 243, .7);

    // 九宫格游戏时不设置背景颜色
    &.nine-grid-game {
      background: transparent !important;
    }
  }
  .logo{
    width: 500px;
    height: auto;
    top: 100px;
  }
  .redbar{
    position: absolute;
    right: 60px;
    top: 260px;
    color: #fff;
    background: #b81c25;
    font-size: 28px;
    padding: 0 40px;
    height: 38px;
    line-height: 32px;
  }
  .type2 .block{
    background-color: #fff8e1;
    box-shadow: none;
    border: 2px solid #000;
    box-sizing: border-box;
  }
  .type1 .block{
    background-color: #fff8e1;
    box-shadow: none;
    border: 2px solid #000;
    box-sizing: border-box;
  }
  .type3{
    .area2{
      .block2{
        background-color: #fff8e1;
        box-shadow: none;
        border: 2px solid #000;
        box-sizing: border-box;
      }
    }
  }
  .type4{
    position: relative;
    .choice-pic{
      width: 150px;
      height: 150px;
      position: absolute;
      top: -200px;
      // right: -150px;
      right: -194px;
      border: 4px solid #951414;
      border-radius: 20px;
    }
    .grid-container {
      display: flex;
      gap: 40px;
      align-items: flex-start;
      justify-content: center;
      margin-left: 100px;
      margin-top: 30px;
      width: 100%;
      max-width: 800px;
      flex-wrap: nowrap;

      @media (max-width: 720px) {
        gap: 10px;
        justify-content: space-between;
        max-width: 100%;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        gap: 20px;
      }

      @media (max-width: 480px) {
        gap: 8px;
      }

      @media (max-width: 320px) {
        gap: 5px;
      }
    }

    .left-grid-wrapper,
    .right-grid-wrapper {
      border: 3px solid #b81c25;
      border-radius: 20px;
      padding: 20px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(5px);
      box-shadow: 0 4px 15px rgba(184, 28, 37, 0.2);
      // flex: 1;
      // min-width: 0;

      @media (max-width: 720px) {
        padding: 8px;
        border-radius: 10px;
        border-width: 2px;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        padding: 15px;
        border-radius: 16px;
      }

      @media (max-width: 480px) {
        padding: 6px;
        border-radius: 8px;
        border-width: 1px;
      }

      @media (max-width: 320px) {
        padding: 4px;
        border-radius: 6px;
      }
    }

    .left-grid-wrapper {
      border-color: #b81c25;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #b81c25, #ff6b6b);
        border-radius: 22px;
        z-index: -1;
        opacity: 0.3;

        @media (max-width: 720px) {
          border-radius: 17px;
        }
      }
    }

    .right-grid-wrapper {
      border-color: #409eff;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #409eff, #67c23a);
        border-radius: 22px;
        z-index: -1;
        opacity: 0.3;

        @media (max-width: 720px) {
          border-radius: 17px;
        }
      }
    }

    .grid-title {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      padding: 8px 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);

      @media (max-width: 720px) {
        font-size: 12px;
        margin-bottom: 6px;
        padding: 3px 0;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        font-size: 16px;
        margin-bottom: 12px;
      }

      @media (max-width: 480px) {
        font-size: 10px;
        margin-bottom: 4px;
        padding: 2px 0;
      }

      @media (max-width: 320px) {
        font-size: 9px;
        margin-bottom: 3px;
        padding: 1px 0;
      }
    }

    .area2 {
      width: 262px;
      margin-left: 0;
      .block2 {
        width: 76px;
        height: 76px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-family: 'fzcsk';
        font-size: 36px;
        background-color: #e5e5e5;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
        border: 2px solid #000;
        border-radius: 14px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
          border-color: #b81c25;
          background-color: #ffb700;
          transform: scale(1.05);
        }

        &:hover {
          transform: scale(1.02);
        }

        @media (max-width: 650px) {
          width: 40px;
          height: 40px;
          font-size: 16px;
          border-radius: 6px;
          margin-bottom: 4px;
        }

        @media (max-width: 480px) {
          width: 32px;
          height: 32px;
          font-size: 14px;
          border-radius: 5px;
          margin-bottom: 3px;
        }

        @media (max-width: 320px) {
          width: 28px;
          height: 28px;
          font-size: 12px;
          border-radius: 4px;
          margin-bottom: 2px;
        }

        @media (min-width: 651px) and (max-width: 1023px) {
          width: 55px;
          height: 55px;
          font-size: 24px;
          border-radius: 10px;
          margin-bottom: 6px;
        }

        @media (min-width: 1024px) and (max-width: 1439px) {
          width: 68px;
          height: 68px;
          font-size: 30px;
          border-radius: 12px;
          margin-bottom: 8px;
        }

        @media (min-width: 1440px) {
          width: 85px;
          height: 85px;
          font-size: 40px;
          border-radius: 15px;
          margin-bottom: 12px;
        }
      }
    }
  }
}

// 小组赛适配5.5米*2.5米大屏
.season2.group1{
  .logo{
    width: 250px;
    top: 50px;
  }
  .left {
    .title{
      margin: 40px auto 20px;
      height: 60px;
      padding-top: 8px;
      .cn{
        font-size: 18px;
      }
      .en{
        font-size: 16px;
      }
    }
    .desc.desc1{
      line-height: 28px;
      margin-top: 30px;
      .cn{
        font-size: 18px;
        margin-bottom: 10px;
      }
      .en{
        font-size: 16px;
      }
    }
  }
  .progress1{
    margin-top: 50px;
    width: 100%;
    .progress-item{
      width: 100px;
      height: 100px;
      padding-top: 0;
      line-height: 84px;
    }
  }
  .redbar{
    top: 130px;
    font-size: 22px;
    padding: 0 20px;
    height: 28px;
    line-height: 22px;
  }
  .right{
    .time-bg{
      width: 580px;
      height: 540px;
      margin-top: 66px;
      font-size: 134px;
      div{
        height: 180px;
      }
    }
  }
}

// 适配电视
.season2.TV {
  .qr{
    display: none;
  }
  .redbar{
    right: 200px;
  }
  .left .desc.desc2 {
    line-height: 36px;
    margin-bottom: 40px;
    .cn{
      font-size: 26px;
    }
    .en{
      font-size: 22px;
    }
  }
}
</style>
